// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.rowCell[data-v-0098b974] {\r\n    height: 48px;\r\n    vertical-align: middle;\r\n    overflow: hidden;\r\n    padding-top: 5px;\n}\n.v-card.riga-alt[data-v-0098b974] {\r\n    background-color: #dbecff;\n}\n.v-card.riga-alt .grigliaTaglie[data-v-0098b974] {\r\n    background-color: #edf5fe;\n}\r\n\r\n\r\n", ""]);
// Exports
module.exports = exports;
